import { useI18n } from 'vue-i18n'

export default function typed_translation(prefix: string, type: string) {
  const i18n = useI18n()
  return function (key: string) {
    return i18n.te(`${prefix}.${type}.${key}`) ? i18n.t(`${prefix}.${type}.${key}`) : i18n.t(`${prefix}.${key}`)
  }
}
